// HACK: патч для страниц со своим роутингом на nginx
export function patchRoute(path = '') {
  if (path.includes('/main-page')) {
    return '/';
  }

  if (path.includes('/brandslist')) {
    return '/brands/';
  }

  return path;
}
